// extracted by mini-css-extract-plugin
export default {"title":"Dthird_title__uVrEd","desc":"Dthird_desc__K4uQC","text":"Dthird_text__KAPu0","Dthird":"Dthird_Dthird__NXkNz"};